/**
 * @file     AnalyticsScripts.tsx
 * @purpose  Client-side analytics mounts. The gtag queue boots from GtagBoot in the root layout head.
 *           First-party Relta analytics ship via the @/services/analytics/relta SDK.
 */
'use client';

import { env } from '@/core/config/env';
import { activeMetaPixelId } from '@/services/analytics/metaPixel';
import { MetaPixelPageViews } from './MetaPixelPageViews';

export function AnalyticsScripts() {
  if (!env.enableAnalytics) return null;

  const metaPixelId = activeMetaPixelId();

  return (
    <>
      {/* Later App Router navigations. The landing PageView is queued by
          MetaPixelBoot, which installs the fbq stub before hydration. */}
      {metaPixelId && <MetaPixelPageViews />}

      {/* CRM capture is owned by protected server submissions. Do not mount
          third-party input scraping here: search and account fields are not leads. */}

    </>
  );
}
